<template>
    <!-- Используем ref для контейнера, хотя виджету нужен именно ID в DOM -->
    <div
        id="delivery-widget"
        ref="widgetContainer"
        class="delivery-widget-container"
    ></div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue';

const props = defineProps({
    city: { type: String, default: 'Москва' }
});

const emit = defineEmits(['select']);
const widgetContainer = ref(null);

// Функция инициализации
const initWidget = () => {
    if (!window.YaDelivery) return;

    window.YaDelivery.createWidget({
        containerId: 'delivery-widget',
        params: {
            city: props.city,
            size: {
                height: "450px",
                width: "100%"
            },
            source_platform_station: process.env.YA_SEND_ID,
            physical_dims_weight_gross: 700,
            delivery_term: 1,
            delivery_price: (price) => price+100 + " руб",
            show_select_button: false,
            filter: {
                type: "pickup_point",
                is_yandex_branded: true,
                payment_methods: ["already_paid"],
                payment_methods_filter: "or"
            }
        },
    });
};

// 0196da96c9127661b70f36f840969fbd

// Обработчик выбора точки
const onPointSelected = (event) => {
    emit('select', event.detail);
};

onMounted(() => {
    const script = document.createElement('script');
    script.src = "https://api-maps.yandex.ru/3.0/?apikey=1b050595-ea3b-49e9-a033-9e5fe8580390&lang=ru_RU" ;
    document.head.appendChild(script);

    const script2 = document.createElement('script');
    script2.src = 'https://ndd-widget.landpro.site/widget.js'
    script2.async = true;
    document.head.appendChild(script2);

    if (window.YaDelivery) {
        initWidget();
    } else {
        document.addEventListener('YaNddWidgetLoad', initWidget);
    }

    document.addEventListener('YaNddWidgetPointSelected', onPointSelected);
});

onUnmounted(() => {
    document.removeEventListener('YaNddWidgetLoad', initWidget);
    document.removeEventListener('YaNddWidgetPointSelected', onPointSelected);

    if (widgetContainer.value) {
        widgetContainer.value.innerHTML = '';
    }
});
</script>

<style scoped>
.delivery-widget-container {
    min-height: 450px;
    width: 100%;
    background-color: #f5f5f5; /* Временный фон пока грузится карта */
}

#delivery-widget > * {
    box-sizing: border-box !important;
}
</style>